/**
 * External dependencies
 */
import classnames from 'classnames'
import { i18n } from 'cartzillagb'

import {
	getAttrName,
} from '~cartzillagb/util'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { RichText } from '@wordpress/block-editor'

const save = props => {
	const {
		className,
		attributes,
	} = props

	const {
		blockId,
		enableContainer,
		title,
		users,
	} = attributes

	const data = {
		'data-attributes': JSON.stringify( attributes ),
	}

	const titleComp = (
		<RichText.Content
			tagName='h2'
			value={ title || __( "Seller of the month", i18n ) }
			className="h3 mb-3 pb-3 pb-lg-4 text-center"
		/>
	)

	if( users.length < 1 ) {
		return ''
	}

	const getAttrValue = ( attrName, defaultValue = '' ) => {
		const value = props.attributes[ getAttrName( attrName ) ]
		return value === 0 ? value : ( value || defaultValue )
	}

	const defaultCarouselOptions = applyFilters( 'cartzillagb.seller-block.main-block.classes', {
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
				}
			}
		],
	}, props )

	let carouselOptions = {
		slidesToShow: getAttrValue( 'slidesToShow', 3 ),
		dots: getAttrValue( 'dots' ),
		arrows: getAttrValue( 'arrows' ),
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowLaptop', 3 ),
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowTablet', 3 ),
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowMobile', 1 ),
				}
			}
		],
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }
	
	return (
		<section
			id={ blockId }
			className={ classnames( [
				className,
				'wp-block-czgb-seller-block',
				'py-5',
			], {} ) }
			data-slick-classes="js-slick-carousel"
			data-slick-attributes={ JSON.stringify( carouselOptions ) }
		>
			<div
				className={  classnames( [
					'py-lg-2',
					enableContainer ? 'container' : '',
				], {} ) }
			>
				{ titleComp }
				<div className="ajax-content" { ...data }></div>
			</div>
		</section>
	)
}

export default save